import React from 'react'

const Loader = () => {
    return (
        <div className='cx-plugin_loader'>
            <img src={ THUMBPRESS.asseturl + '/img/loader.gif'} />
        </div>
     );
}

export default Loader;